export default __webpack_public_path__ + "static/media/V2-CARROUSEL_1.b088e9cb.png";